// Sell Car Form JavaScript
// Håndterer bil vurdering og redirect til smartsalg

(function () {
// @ts-nocheck
"use strict";

  // Local state
  let isSubmitting = false;
  let currentValuation = null;

  // Fetch last submission date for sell car form
  async function fetchLastSubmission() {
    const token = localStorage.getItem("carclub_token");
    if (!token) return null;

    try {
      const response = await fetch("/api/contact/last-sell-submission", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data.lastSubmissionDate;
      }
    } catch (error) {
      console.error("Error fetching last sell submission:", error);
    }
    return null;
  }

  // Display last submission indicator
  function displayLastSubmissionIndicator(lastDate) {
    if (!lastDate) return;

    const indicator = document.querySelector(
      '.last-submission-indicator[data-form-type="sell"]'
    );
    if (!indicator) return;

    const dateSpan = indicator.querySelector(".submission-date");
    if (dateSpan) {
      const date = new Date(lastDate);
      const danishMonths = [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec",
      ];
      const formatted = `${date.getDate()}. ${
        danishMonths[date.getMonth()]
      } ${date.getFullYear()}`;
      dateSpan.textContent = `Sidste indsendelse: ${formatted}`;
    }
    indicator.style.display = "flex";
  }

  // Validate license plate field
  function validateLicensePlate(field) {
    const errorElement = document.getElementById(`error-${field.id}`);
    if (!errorElement) return true;

    errorElement.textContent = "";

    if (!field.value.trim()) {
      errorElement.textContent = "Nummerplade er påkrævet";
      return false;
    }

    return true;
  }

  // Show loading state
  function showLoading(show) {
    const submitBtn = document.getElementById("sellCarFormGetValuationBtn");
    const submitText = document.getElementById("sellCarFormGetValuationText");
    const loadingText = document.getElementById("sellCarFormLoadingText");

    if (show) {
      submitBtn.disabled = true;
      submitText.style.display = "none";
      loadingText.style.display = "inline";
    } else {
      submitBtn.disabled = false;
      submitText.style.display = "inline";
      loadingText.style.display = "none";
    }
  }

  // Show error message
  function showError(message) {
    const errorElement = document.getElementById("sellCarFormError");
    if (errorElement) {
      errorElement.textContent = message;
    }
  }

  // Clear error message
  function clearError() {
    const errorElement = document.getElementById("sellCarFormError");
    if (errorElement) {
      errorElement.textContent = "";
    }
  }

  // Format currency in DKK
  function formatCurrency(value) {
    return new Intl.NumberFormat("da-DK", {
      style: "currency",
      currency: "DKK",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }

  // Format mileage
  function formatMileage(value) {
    return new Intl.NumberFormat("da-DK").format(value) + " km";
  }

  // Show valuation section with data
  function showValuation(valuation, hasValuationData) {
    const section = document.getElementById("sellCarFormValuationSection");
    const valuationDataBox = document.getElementById(
      "sellCarFormValuationData"
    );
    const noValuationMessage = document.getElementById(
      "sellCarFormNoValuation"
    );
    const lowValue = document.getElementById("sellCarFormLowValue");
    const highValue = document.getElementById("sellCarFormHighValue");
    const mileageValue = document.getElementById("sellCarFormMileageValue");
    const initialForm = document.getElementById("sellCarForm");

    if (hasValuationData) {
      // Vis vurderingsdata
      if (valuationDataBox) {
        valuationDataBox.style.display = "block";
      }
      if (noValuationMessage) {
        noValuationMessage.style.display = "none";
      }

      if (lowValue) {
        lowValue.textContent = formatCurrency(valuation.low);
      }
      if (highValue) {
        highValue.textContent = formatCurrency(valuation.high);
      }
      if (mileageValue) {
        mileageValue.textContent = formatMileage(valuation.mileage);
      }
    } else {
      // Skjul vurderingsdata, vis besked
      if (valuationDataBox) {
        valuationDataBox.style.display = "none";
      }
      if (noValuationMessage) {
        noValuationMessage.style.display = "block";
      }
    }

    // Skjul initial formular når vurdering vises
    if (initialForm) {
      initialForm.style.display = "none";
    }

    if (section) {
      section.style.display = "block";
    }
  }

  // Hide valuation section
  function hideValuation() {
    const section = document.getElementById("sellCarFormValuationSection");
    const initialForm = document.getElementById("sellCarForm");

    if (section) {
      section.style.display = "none";
    }

    // Vis initial formular igen
    if (initialForm) {
      initialForm.style.display = "block";
    }
  }

  // Handle get valuation form submission
  async function handleGetValuation(event) {
    event.preventDefault();

    if (isSubmitting) return;

    const licensePlateInput = document.getElementById(
      "sellCarFormLicensePlate"
    );
    if (!validateLicensePlate(licensePlateInput)) {
      return;
    }

    const licensePlate = licensePlateInput.value.trim();
    isSubmitting = true;
    showLoading(true);
    clearError();
    hideValuation();

    try {
      const response = await fetch(
        `/api/contact/vehicle-valuation/${encodeURIComponent(licensePlate)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const valuation = await response.json();
        currentValuation = {
          licensePlate: licensePlate,
          dmrId: valuation.dmrId || 0,
          mileage: valuation.mileage || 0,
          high: valuation.high || 0,
          low: valuation.low || 0,
        };
        showValuation(currentValuation, true);
      } else if (response.status === 404) {
        // Ingen vurdering fundet, men tilbyd stadig salg
        currentValuation = {
          licensePlate: licensePlate,
          dmrId: 0,
          mileage: 0,
          high: 0,
          low: 0,
        };
        showValuation(currentValuation, false);
      } else {
        const errorData = await response.json().catch(() => ({}));
        showError(
          errorData.message || "Der opstod en fejl. Prøv venligst igen."
        );
      }
    } catch (error) {
      showError("Der opstod en fejl. Prøv venligst igen.");
    } finally {
      isSubmitting = false;
      showLoading(false);
    }
  }

  // Handle "Yes, I want to sell" button click
  async function handleYesClick() {
    if (!currentValuation) return;

    try {
      // Save sell lead to database
      const headers = {
        "Content-Type": "application/json",
      };

      // Add Authorization header if user is logged in
      const token = localStorage.getItem("carclub_token");
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await fetch("/api/contact/sell-car", {
        method: "POST",
        headers: headers,
        body: JSON.stringify(currentValuation),
      });

      // Åbn altid smartsalg - gem i database hvis muligt
      const url = `https://tjekbil.dk/smartsalg?rc=bh223112&reg=${encodeURIComponent(
        currentValuation.licensePlate
      )}`;
      window.open(url, "_blank");

      // Reset form efter redirect
      setTimeout(() => {
        handleNoClick();
      }, 500);
    } catch (error) {
      // Selv ved fejl, åbn smartsalg (brugeren vil stadig sælge)
      const url = `https://tjekbil.dk/smartsalg?rc=bh223112&reg=${encodeURIComponent(
        currentValuation.licensePlate
      )}`;
      window.open(url, "_blank");

      setTimeout(() => {
        handleNoClick();
      }, 500);
    }
  }

  // Handle "No thanks" button click
  function handleNoClick() {
    // Reset form
    const form = document.getElementById("sellCarForm");
    if (form) {
      form.reset();
    }
    hideValuation();
    clearError();
    currentValuation = null;
  }

  // Initialize function
  // Helper function to check if user is logged in
  function isLoggedIn() {
    return !!localStorage.getItem("carclub_token");
  }

  // Setup modal triggers
  async function setupModalTriggers() {
    const triggerBox = document.getElementById("sellCarFormTrigger");
    const modalElement = document.getElementById("sellCarFormModal");

    if (!triggerBox || !modalElement) {
      return;
    }

    // Fetch and display last submission
    const lastDate = await fetchLastSubmission();
    if (lastDate) {
      displayLastSubmissionIndicator(lastDate);
    }

    const formModal = new bootstrap.Modal(modalElement);

    // Click event på trigger box - åbn modal direkte (ingen login check)
    triggerBox.addEventListener("click", function () {
      formModal.show();
    });
  }

  function initializeSellCarForm() {
    // Setup modal triggers
    setupModalTriggers();

    // Setup form submission
    const form = document.getElementById("sellCarForm");
    if (form) {
      form.addEventListener("submit", handleGetValuation);
    }

    // Setup Yes button
    const yesBtn = document.getElementById("sellCarFormYesBtn");
    if (yesBtn) {
      yesBtn.addEventListener("click", handleYesClick);
    }

    // Setup No button
    const noBtn = document.getElementById("sellCarFormNoBtn");
    if (noBtn) {
      noBtn.addEventListener("click", handleNoClick);
    }

    // Setup field validation
    const licensePlateInput = document.getElementById(
      "sellCarFormLicensePlate"
    );
    if (licensePlateInput) {
      licensePlateInput.addEventListener("blur", function () {
        validateLicensePlate(this);
      });
    }
  }

  // Initialize on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeSellCarForm);
  } else {
    // DOM is already loaded
    initializeSellCarForm();
  }
})();
